import React from 'react';
import { Button, Col, FormControl, Row } from 'react-bootstrap';
import { connect as connectR } from 'react-redux';
import translate from '../translate';

import LargeCard from '../main/large-card';
import ValidatorFormGroup from '../main/validator-form-group';
import _ from 'lodash';
import { RootState } from '../../store';
import {
    ConfirmChangeEmailDto,
    getConfirmEmailChange,
    RequestEmailChange,
} from '../../store/changeEmailSlice';
import { RequestStatus } from '../../store/network/managedRequest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { PbGenericRequest } from '../../store/pbRequestSlice';
import { PbRequest } from '../../store/pbRequest';

const DUPLICATE_EMAIL = 'DUPLICATE_EMAIL';
const INVALID_EMAIL = 'EMAIL_INVALID';

export interface ChangeEmailProps {
    email: string;
    reenteredEmail: string;
    strings?: ChangeEmailFormTexts;
    getConfirmEmailChange: () => void;
    loggedInUseEmail?: string;
    RequestEmailChange: (code: string) => void;
    changeEmailRequest: PbGenericRequest;
    getChangeEmailRequest: PbGenericRequest;
    changeEmailData: ConfirmChangeEmailDto;
}

export interface ChangeEmailFormTexts {
    _utils: { sprintf: (str: string, ...args: any) => string };
    text?: string;
    requestButtonText?: string;
    invalidEmail?: string;
    newEmailHeader?: string;
    requestChangeButtonText?: string;
    newEmailConfirmHeader?: string;
    missingEmail?: string;
    duplicateEmail?: string;
    unknownError?: string;
    requestedEmail?: string;
    currentEmail?: string;
    expiredAt?: string;
    success?: string;
    editButtonText: string;
    title: string;
    activeRecordTitle: string;
}

interface ChangeEmailState {
    email: string;
    reenteredEmail: string;
    valid: boolean;
    submitted?: boolean;
    open?: boolean;
}

interface ChangeEmailStateChange {
    email?: string;
    reenteredEmail?: string;
    submitted?: boolean;
    open?: boolean;
}

class ManageEmailAddress extends React.Component<
    ChangeEmailProps,
    ChangeEmailState
> {
    _handleStateChange = (stateChange: ChangeEmailStateChange) => {
        const newData = _.extend({}, this.state) as ChangeEmailState;
        if (stateChange.email) {
            newData.email = stateChange.email;
        }
        if (stateChange.reenteredEmail) {
            newData.reenteredEmail = stateChange.reenteredEmail;
        }
        if (stateChange.open != null && stateChange.open != this.state.open) {
            newData.open = stateChange.open;
        }
        if (stateChange.submitted && !this.state.submitted) {
            newData.submitted = stateChange.submitted;
            newData.reenteredEmail = '';
            newData.email = '';
            this.props.getConfirmEmailChange();
        }
        newData.valid = newData.email === newData.reenteredEmail;
        this.setState(newData);
    };

    componentDidMount() {
        this.props.getConfirmEmailChange();
    }

    renderErrorStatus = () => {
        if (this.props.changeEmailRequest.errors.length > 0) {
            if (this.props.changeEmailRequest.errors[0] === DUPLICATE_EMAIL) {
                return (
                    <div className="alert alert-danger pull-left">
                        {this.props.strings.duplicateEmail}
                    </div>
                );
            } else if (
                this.props.changeEmailRequest.errors[0] === INVALID_EMAIL
            ) {
                return (
                    <div className="alert alert-danger pull-left">
                        {this.props.strings.invalidEmail}
                    </div>
                );
            }
        }
        return (
            <div className="alert alert-danger pull-left">
                {this.props.strings.unknownError}
            </div>
        );
    };
    renderRequestStatus() {
        const hasErrors: boolean =
            this.props.changeEmailRequest.status === RequestStatus.FAILURE;
        const isSuccess: boolean =
            this.props.changeEmailRequest.status === RequestStatus.SUCCESS;

        if (hasErrors) {
            return this.renderErrorStatus();
        } else if (isSuccess) {
            return (
                <div className="pull-left">
                    <span style={{ marginRight: '0.2em' }}>
                        <FontAwesomeIcon color={'green'} icon={faCheckCircle} />
                    </span>
                    {this.props.strings.success}
                    <br />
                </div>
            );
        } else {
            return <div />;
        }
    }
    renderOldRequest() {
        const style = {
            marginTop: '1em',
        };
        const dataExist =
            this.props.getChangeEmailRequest.status === RequestStatus.SUCCESS;
        const newDate = dataExist
            ? new Date(this.props.changeEmailData?.ctime).toLocaleString(
                  navigator.language,
                  {
                      year: 'numeric',
                      month: 'short',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                  }
              )
            : '';
        return (
            <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                    <ValidatorFormGroup
                        label={this.props.strings.currentEmail}
                        hideErrorLabel
                    >
                        <FormControl
                            type={'text'}
                            className={'input-text-color'}
                            value={this.props.loggedInUseEmail || ''}
                            readOnly
                        />
                    </ValidatorFormGroup>
                    {dataExist && (
                        <ValidatorFormGroup
                            label={this.props.strings.requestedEmail}
                            hideErrorLabel
                            helpLabel={this.props.strings._utils.sprintf(
                                this.props.strings.expiredAt,
                                newDate
                            )}
                        >
                            <FormControl
                                type={'text'}
                                className={'input-text-color'}
                                value={
                                    this.props.changeEmailData?.updated_email ||
                                    ''
                                }
                                readOnly
                            />
                        </ValidatorFormGroup>
                    )}
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                    <Button
                        type="button"
                        disabled={this.state.open}
                        style={style}
                        className="btn btn-primary pull-right m-"
                        onClick={(event) => {
                            this._handleStateChange({ open: true });
                        }}
                    >
                        {dataExist
                            ? this.props.strings.requestChangeButtonText
                            : this.props.strings.editButtonText}
                    </Button>
                </Col>
            </Row>
        );
    }
    renderEditForm() {
        if (this.state.open) {
            return (
                <LargeCard title={[this.props.strings.title]}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div>
                                <ValidatorFormGroup
                                    label={this.props.strings.newEmailHeader}
                                    hideErrorLabel
                                    errorLabel=""
                                >
                                    <FormControl
                                        type="text"
                                        className={`input-text-color`}
                                        name="email"
                                        onChange={(event) => {
                                            const eventValue = (
                                                event.target as HTMLInputElement
                                            ).value;
                                            this._handleStateChange({
                                                email: eventValue,
                                            });
                                        }}
                                        required
                                    />
                                </ValidatorFormGroup>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div>
                                <ValidatorFormGroup
                                    label={
                                        this.props.strings.newEmailConfirmHeader
                                    }
                                    hideErrorLabel
                                    errorLabel=""
                                >
                                    <FormControl
                                        type="text"
                                        className={`input-text-color`}
                                        name="reenteredEmail"
                                        onChange={(event) => {
                                            const eventValue = (
                                                event.target as HTMLInputElement
                                            ).value;
                                            this._handleStateChange({
                                                reenteredEmail: eventValue,
                                            });
                                        }}
                                        required
                                    />
                                </ValidatorFormGroup>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Button
                                type="button"
                                disabled={!this.state.valid}
                                className="btn btn-primary pull-right "
                                onClick={(event) => {
                                    this.sendRequest();
                                }}
                            >
                                {this.props.strings.requestButtonText}
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            {this.renderRequestStatus()}
                        </Col>
                    </Row>
                </LargeCard>
            );
        }
    }
    sendRequest() {
        this._handleStateChange({ submitted: false, open: false });
        this.props.RequestEmailChange(this.state.email);
        this._handleStateChange({ submitted: true });
    }

    render(): React.ReactElement<any> | null {
        return (
            <div>
                <LargeCard title={[this.props.strings.activeRecordTitle]}>
                    {this.renderOldRequest()}
                </LargeCard>
                {this.renderEditForm()}
            </div>
        );
    }

    state: ChangeEmailState = {
        email: '',
        reenteredEmail: '',
        valid: false,
        open: false,
    };
}

export default connectR(
    (store: RootState) => ({
        changeEmailRequest: store.pbRequest[PbRequest.CHANGE_EMAIL],
        loggedInUseEmail: store.user.legacyUser?.email,
        getChangeEmailRequest: store.pbRequest[PbRequest.GET_CHANGE_EMAIL],
        changeEmailData: store.changeEmail.changeEmailData,
    }),
    {
        RequestEmailChange,
        getConfirmEmailChange,
    }
)(translate('ChangeEmailForm')(ManageEmailAddress));
